import React from 'react';
import {Form, List, Edit, Submit} from 'components';
import {cookies, api, config, encrypt} from 'helpers';

// only for development mode
export function Login() {
  return (
    <main>
      <Form onSubmit={submit}>
        <List>
          <Edit label="Email" name="email" />
          <Edit label="Password" name="password" type="password" />
          <Submit>
            {[ 'Login', 'Logging in..' ]}
          </Submit>
        </List>
      </Form>
    </main>
  );
}

async function submit(values) {
  try {
    const {token} = await api('/login/', {
      ...values,
      device: 'Web'
    });
    cookies.set('token', encrypt(token), { expires: 365, domain: config.appHost });
    window.location = '/';
  } catch (error) {
    console.error(error);
  }
}
